import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";

export default function NotificationsIcon(props) {
  const width = props.width || 30;
  const height = props.height || 30;

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M9.85 4.2377L8.25 2.3252L2.5 7.1377L4.1125 9.05019L9.85 4.2377ZM27.5 7.1502L21.75 2.3252L20.1375 4.2377L25.8875 9.0627L27.5 7.1502ZM15 5.0002C8.7875 5.0002 3.75 10.0377 3.75 16.2502C3.75 22.4627 8.775 27.5002 15 27.5002C21.2125 27.5002 26.25 22.4627 26.25 16.2502C26.25 10.0377 21.2125 5.0002 15 5.0002ZM15 25.0002C10.1625 25.0002 6.25 21.0877 6.25 16.2502C6.25 11.4127 10.1625 7.5002 15 7.5002C19.8375 7.5002 23.75 11.4127 23.75 16.2502C23.75 21.0877 19.8375 25.0002 15 25.0002ZM11.25 13.7502H15.7875L11.25 19.0002V21.2502H18.75V18.7502H14.2125L18.75 13.5002V11.2502H11.25V13.7502Z"
          fill="url(#paint0_linear_notifications)"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_notifications"
            x1="2.5"
            y1="7.78483"
            x2="14.6704"
            y2="32.4798"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
